<template>
  <div class="form-group">
    <label v-if="label" :for="name">{{ label }}</label>
    <span class="text-danger" v-if="required"> *</span>

    <textarea
      class="form-control"
      :id="name"
      :name="name"
      :rows="rows"
      :placeholder="placeholder"
      v-model="vModel"
      :disabled="disabled"
      @input="handleInput"
      @blur="validateValue"
    ></textarea>

    <small
      class="form-text text-danger"
      v-if="validationError || (errors && errors[name])"
    >
      {{ validationError || errors[name][0] }}
    </small>
  </div>
</template>

<script>
import Lang from "@lang";

export default {
  props: {
    label: String,
    name: { type: String, required: true },
    model: { type: [Object, Array], required: true },
    errors: { type: [Object, Array], default: () => ({}) },
    rows: { type: Number, default: 4 },
    disabled: Boolean,
    required: Boolean,
    rules: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      validationError: "",
      hadInvalidInput: false,
      patterns: {
        english: {
          regex: /^[A-Za-z\s]*$/,
          message: Lang.get("messages.english_only")
        },
        arabic: {
          regex: /^[\u0600-\u06FF\s]*$/,
          message: Lang.get("messages.arabic_only")
        },
        both: {
          regex: /^[A-Za-z\u0600-\u06FF\s]*$/,
          message: Lang.get("messages.arabic_or_english_only")
        }
      }
    };
  },

  computed: {
    placeholder() {
      return this.label ? `${Lang.get("messages.enter")} ${this.label}` : "";
    },
    vModel: {
      get() {
        return _.get(this.model, this.name);
      },
      set(newValue) {
        if (this.name.includes(".")) {
          _.set(this.model, this.name, newValue);
        } else {
          this.$set(this.model, this.name, newValue);
        }
      }
    }
  },

  methods: {
    handleInput(event) {
      let value = event.target.value;
      let originalValue = value;

      this.hadInvalidInput = false;

      if (this.rules?.pattern) {
        const base = this.rules.pattern.base;
        let validPattern = null;

        if (base === "english") validPattern = /[A-Za-z\s]/;
        else if (base === "arabic") validPattern = /[\u0600-\u06FF\s]/;
        else if (base === "both") validPattern = /[A-Za-z\u0600-\u06FF\s]/;

        if (validPattern) {
          const filtered = value
            .split("")
            .filter((char) => validPattern.test(char))
            .join("");
          if (filtered !== value) {
            this.hadInvalidInput = true;
          }
          value = filtered;
        }
      }

      this.updateValue(value);
      this.validateValue(value, originalValue);
    },

    validateValue(value, originalValue = null) {
      const errors = [];

      if (typeof value === "object") value = value.target.value;

      // Required
      if (this.required && !value) {
        if (this.hadInvalidInput && originalValue?.length > 0) {
          errors.push(
            this.rules.pattern?.message || Lang.get("messages.invalid_format")
          );
        } else {
          errors.push(Lang.get("messages.field_required"));
        }
      }

      // Pattern check
      if (value && this.rules?.pattern) {
        const pattern =
          this.rules.pattern.base === "custom"
            ? this.rules.pattern.regex
            : this.patterns[this.rules.pattern.base]?.regex;

        if (pattern && !pattern.test(value)) {
          errors.push(this.rules.pattern.message);
        }
      }

      this.validationError = errors[0] || "";
      return errors.length === 0;
    },

    updateValue(value) {
      if (this.name.includes(".")) {
        _.set(this.model, this.name, value);
      } else {
        this.$set(this.model, this.name, value);
      }
      this.$emit("input", value);
      this.$emit("change", value);
    }
  }
};
</script>
